import { schema } from 'normalizr';

import { parts } from '../part/schema';

export const supplier = new schema.Entity(
  'suppliers',
  {
    parts,
  },
  { idAttribute: 'locator' },
);

export const suppliers = [supplier];
